import * as ResponsiveFns from '../utilities/ResponsiveFns';
import React, {useEffect, useRef} from 'react';
import * as ContentsFns from '../ContentsFns';
import SummaryDiv from './SummaryDiv';

function App(props) {

  var allStyles = props.allStyles;
  var thisItem = props.thisItem;
  var currentList = props.currentList;
  var internalVariables = props.internalVariables;
  var width = props.width;
  var height = props.height;
  var inputValues = props.inputValues;
  var ownVariables = props.ownVariables;
  var urlParamsForExecution = props.urlParamsForExecution;
  var urlHeader = props.urlHeader;
  var clickEditItem = props.clickEditItem;
  var interactionFn = props.interactionFn;
  var doAScreenRef = props.doAScreenRef;
  var itemPath = props.itemPath;

  var upwardInfo = props.upwardInfo;
  var setInputValues = props.setInputValues;
  var editPieces = props.editPieces;
  var itemEdited = props.itemEdited;
  var setItemEdited = props.setItemEdited;
  var setIsClickingOnContentDiv = props.setIsClickingOnContentDiv;
  var isClickingOnContentDiv = props.isClickingOnContentDiv;
  var addWhereText = props.addWhereText;
  var potentiallyAddWhichItem = props.potentiallyAddWhichItem;
  var hoveringWhere = props.hoveringWhere;
  var actHoveringWhere = props.actHoveringWhere;
  var organicChanges = props.organicChanges;
  var userNos = props.userNos;
  var userID = props.userID;
  var clickFn = props.clickFn;
  var draggable = props.draggable;
  var onDragStart = props.onDragStart;
  var onDragEnd = props.onDragEnd;
  var onDrag = props.onDrag;
  var popUps = props.popUps;
  var setPopUps = props.setPopUps;
  var stylesToAdd = props.stylesToAdd;
  var addClassNames = props.addClassNames;
  var addCCColWidth = props.addCCColWidth;
  var screenSelectionChoices = props.screenSelectionChoices;
  var setScreenSelectionChoices = props.setScreenSelectionChoices;
  var flashHighlight = props.flashHighlight;
  var chains = props.chains;
  var lastEdited = props.lastEdited;
  var counter = props.counter;


  const ref1 = useRef();

  useEffect(()=>{
    doAScreenRef(ref1, itemPath);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

    var detailClass = 'detail' + allStyles.detailsStyle;
    var summaryClass = 'summary' + allStyles.detailsStyle;
    var divClass = 'detailDiv' + allStyles.detailsStyle;

    var summaryItems = thisItem.i;
    var sortedSummaryItemKeys = ResponsiveFns.sortAListBasedOnOrd(summaryItems);

    function doASummaryDiv(thisCard, thisCardPath, toAddUpwardInfo, summaryPieces, coverWithHeaderObviouslyFalse, index, currentList){

      summaryPieces.push(<SummaryDiv key={summaryPieces.length} chains={chains} thisCard={thisCard} thisCardPath={thisCardPath} allStyles={allStyles} currentList={currentList} internalVariables={internalVariables} width={width} height={height} inputValues={inputValues} ownVariables={ownVariables} clickEditItem={clickEditItem} interactionFn={interactionFn} doAScreenRef={doAScreenRef} upwardInfo={upwardInfo} setInputValues={setInputValues} editPieces={editPieces} itemEdited={itemEdited} setItemEdited={setItemEdited} setIsClickingOnContentDiv={setIsClickingOnContentDiv} isClickingOnContentDiv={isClickingOnContentDiv} addWhereText={addWhereText} potentiallyAddWhichItem={potentiallyAddWhichItem} hoveringWhere={hoveringWhere} actHoveringWhere={actHoveringWhere} organicChanges={organicChanges} userNos={userNos} userID={userID} popUps={popUps} setPopUps={setPopUps} screenSelectionChoices={screenSelectionChoices} setScreenSelectionChoices={setScreenSelectionChoices} toAddUpwardInfo={toAddUpwardInfo} divClass={divClass} detailClass={detailClass} summaryClass={summaryClass} flashHighlight={flashHighlight} urlParamsForExecution={urlParamsForExecution} urlHeader={urlHeader} lastEdited={lastEdited} counter={counter}/>)    
    }


    var summaryPieces = ContentsFns.getCardItems(sortedSummaryItemKeys, itemPath, summaryItems, currentList, internalVariables, width, height, upwardInfo, inputValues, ownVariables, urlParamsForExecution, urlHeader, chains, interactionFn, doASummaryDiv, false);
    if (sortedSummaryItemKeys.length === 0 && !interactionFn){
      summaryPieces = <p className='card-text'><center>[No Summary Pieces]</center></p>
    }

    stylesToAdd.overflow = 'scroll';
    return <div style={stylesToAdd} ref={ref1} onClick={clickFn} className={addClassNames + addCCColWidth} draggable={draggable} onDragStart={onDragStart} onDrag={onDrag} onDragEnd={onDragEnd}>
              {summaryPieces}
            </div>

}
//




export default App;
